<template>
    <div>
        <b-row align-h="center">
            <div class="loader"></div>
        </b-row>

        <b-row class="pt-4" align-h="center">
            <p>Loading...</p> 
        </b-row>

    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  /* border-top: 16px solid #3498db; */
  border-top: 16px solid #DA2a2a;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 1.2s linear infinite; /* Safari */
  animation: spin 1.2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
